<template>
  <Photos year="2022" :min-date="1647388800" :max-date="1647561600" date-text="March 16&ndash;18" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
